import { SelectionType } from '@convergence/types';
import { ActionInputProps } from './types';
import { SelectionActionInputSelector } from './type-selectors/selection-action-input-selector';
import { actionDataFromTreeAndPath } from './util';

export function AnalysisSelectAction(props: ActionInputProps<SelectionType>) {
  const actionData = actionDataFromTreeAndPath(
    props.tree,
    props.propertyPath
  ) ?? {
    type: 'value',
    value: props.value._options[0] || ''
  };
  return (
    <div className="py-2">
      <label className="inline-flex items-center">
        {props.name}
        <SelectionActionInputSelector
          valueSchema={props.value}
          actionData={actionData}
          setActionData={(data) => {
            props.onChange(props.propertyPath, data);
          }}
        />
      </label>
    </div>
  );
}
